<template>
    <div id="solution_type_jstask">
        <!-- <pre>{{ jsTask }}</pre> -->
    </div>
</template>

<script>
import { solutionMixin } from '@/utils/solution-mixin';
import { layoutMixin } from '@/utils/layout-mixin';

function decodeBase64ToUTF8(base64) {
    let binaryStr = atob(base64);
    let charCodes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
        charCodes[i] = binaryStr.charCodeAt(i);
    }
    return new TextDecoder('utf-8').decode(charCodes);
}

export default {
    mixins: [solutionMixin, layoutMixin],
    props: {
        spot: {},
    },
    data() {
        return {
            taskScript: null,
            TaskScriptInput: {
                userInput: [],
                // "taskContent": "Berlin, the vibrant capital of Germany, is known for its rich history, cultural diversity and [modern] architecture. From its majestic [museums] to its bustling [streets], Berlin is a city of contrasts and surprises. The Berlin Wall, once a symbol of division, has become a [symbol] of freedom and unity. The many parks and [green spaces] offer residents and visitors a place to relax and unwind.",
                // "correctOrder": ["modern", "museums", "streets", "symbol", "green spaces"],
                // "textFields": ["Toronto", "Vancouver", "Hawaii", "Peking", "Bangkok", "Delhi"],
                // "imagePieces": [],
                // "showButtons": true,
                userPlaceholder: [],
            },
            debounceTimeout: null, // Store the timeout ID for debouncing
            prevUserInput: null,    // Store the previous state of userInput for comparison
            inputCheckInterval: null, // Store the interval ID for checking user input
            taskInteracted: false, // Set once the widget reports the first user interaction; gates the solve input

        };
    },
    computed: {
        jsTask(){
            let jsCode = this.$store.getters['spots/jsTaskById'](this.spot.raetsel.js_task_id);
            if(jsCode){
                // console.log(jsCode);
                try{
                    jsCode = decodeBase64ToUTF8(jsCode); // decodeBase64
                    jsCode = jsCode.replace(/’/g, '\'');
                    return jsCode;
                }
                catch (e) {
                    console.error('Failed to decode Base64 string:', e);
                    return null;
                }
            }
            return null;
        },

    },

    mounted() {
    },

    beforeDestroy() {
        if (this.inputCheckInterval) {
            clearInterval(this.inputCheckInterval);
        }
    },

    watch: {
        jsTask: {
            handler(newJsTask) {
                if (newJsTask) {
                    this.$nextTick(() => {
                        this.renderJsTask(newJsTask);
                    });

                }
            },
            immediate: true,
        },

        hasUserInput: {
            handler(val) {
                if (val) {
                    // Disable input if task has user input
                    this.taskScript.onDisableTask();
                    //stop watching the user input
                    if (this.inputCheckInterval) {
                        clearInterval(this.inputCheckInterval);
                    }
                }
            },
        },

        'spot.raetsel.js_task_settings': {
            handler() {
                // Add task settings
                this.mergeJsTaskSettings();
                //this.userInput - can be found in mixin solution-mixin.js
                this.TaskScriptInput.userInput = Array.isArray(this.userInput) && this.userInput[0] ? JSON.parse(this.userInput[0]) : [];   
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {

        mergeJsTaskSettings() {
            if (this.spot.raetsel && this.spot.raetsel.js_task_settings) {
                try {
                    const settings = JSON.parse(`{${this.spot.raetsel.js_task_settings}}`);
                    Object.assign(this.TaskScriptInput, settings);
                } catch (e) {
                    console.error('Failed to parse js_task_settings:', e);
                }
            }
        },

        /** 
         * Safely evaluates and renders the JavaScript code, in a sandboxed environment.
         * Relies on the assumption that the code will always create the TaskScriptTemplate variable.
         */
        renderJsTask(code) {
            // console.log(code);
            this.taskInteracted = false;
            this.prevUserInput = null;
            const container = document.getElementById('solution_type_jstask');
            // Clear existing content in the container
            container.innerHTML = '';

            const iframe = document.createElement('iframe');

            iframe.style.width = '100%';
            // iframe.style.border = '1px solid #000';
            iframe.style.border = '0';
            iframe.style.display = 'block';

            container.appendChild(iframe);
           // Wait for a short moment to ensure iframe's document is ready
           // This issue seems to be on mozilla engine -> 129.0.2
            setTimeout(() => {
                const iframeWindow = iframe.contentWindow;
                const iframeDocument =iframe.contentDocument || iframe.contentWindow.document;        
                
                // Create a container inside the iframe
                const jsTaskInputContainer = iframeDocument.createElement('div');
                jsTaskInputContainer.className = 'content'; // Apply the .content class
                iframeDocument.body.appendChild(jsTaskInputContainer);

                // Set the root font size of the iframe document
                this.setIframeRootFontSize(iframeDocument);
                
                // Inject custom CSS and font link into the iframe
                this.injectFontAndCSS(iframeDocument, () => {
                    // Adjust iframe height based on content after font is loaded
                    this.adjustIframeHeight(iframe, jsTaskInputContainer);
                });

                // Inject TaskScriptInput and container variables into iframe global context
                iframeWindow.TaskScriptInput = JSON.parse(JSON.stringify(this.TaskScriptInput));
                iframeWindow.container = jsTaskInputContainer;
                iframeWindow.hostOnTaskInteracted = () => {
                    this.taskInteracted = true;
                };

                // Define custom functions as a string
                const customFunctions = `
                    // branding colors
                    var colorBackground = "${this.theme.backgroundColor}";
                    var colorText = "${this.theme.textColor}";
                    var colorBtnPrimary = "${this.theme.btnColorPrimary}";
                    var colorBtnSecondary = "${this.theme.btnSecondary}";
                    var colorBtnText = "${this.theme.btnTextColor}";

                    // Function to render task input form
                    function onRenderTaskInput() {
                        TaskScriptTemplate.renderTaskInput()
                    }

                    // Function to check answers
                    function onCheckUserInput() {                    
                        const checkedAnswers = TaskScriptTemplate.checkUserInput();
                        return checkedAnswers;
                    }

                    function onDisableTask() {
                        TaskScriptTemplate.disableTask()
                    }

                    function shuffleArray(array) {
                        for (let i = array.length - 1; i > 0; i--) {
                            const j = Math.floor(Math.random() * (i + 1));
                            [array[i], array[j]] = [array[j], array[i]];
                        }
                        return array;
                    }

                    function equalsIgnoringCase(a, b) {
                        return typeof a === 'string' && typeof b === 'string'
                            ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
                            : a === b;
                    }
                `;

                // Evaluated after the widget code so a widget-defined onTaskHasBeenInteracted cannot
                // shadow it; _hasInteracted stays a global the widget's checkUserInput() can read
                const interactionBridge = `
                    var _hasInteracted = false;
                    function onTaskHasBeenInteracted(interacted) {
                        if (_hasInteracted) return;
                        _hasInteracted = true;
                        hostOnTaskInteracted(interacted);
                    }
                `;

                try {


                    // Inject custom functions into the iframe
                    iframeWindow.eval(customFunctions);

                    // Evaluate the main script
                    iframeWindow.eval(code);
                    iframeWindow.eval(interactionBridge);
                    
                    if (iframeWindow.TaskScriptTemplate) { // task script contains TaskScriptTemplate object
                        if (iframeWindow.TaskScriptTemplate.renderTaskInput) { // TaskScriptTemplate object contains renderTaskInput function
                            this.taskScript = iframeWindow;
                            this.taskScript.onRenderTaskInput();
                            if (this.hasUserInput) {
                                // Disable input if task has user input
                                this.taskScript.onDisableTask();
                            }


                            // Adjust iframe height based on content
                            this.$nextTick(() => {
                                this.adjustIframeHeight(iframe, jsTaskInputContainer);
                            });

                            // Observe changes in the iframe body to adjust height dynamically
                            const observer = new MutationObserver(() => {
                                this.adjustIframeHeight(iframe, jsTaskInputContainer);
                            });

                            observer.observe(iframeDocument.body, { childList: true, subtree: true, attributes: true, characterData: true });
                            
                            // Start checking user input periodically
                            this.startCheckingUserInput();

                        } else {
                            console.error("TaskScriptTemplate.renderTaskInput is not defined.");
                        }
                        

                    }
                    else{
                        console.error("TaskScriptTemplate is not defined in the provided code.");
                    }
                } catch (e) {
                    console.error('Error evaluating JavaScript code:', e);
                }
            }, 100);  // 100ms delay to ensure document readiness
        },

        setIframeRootFontSize(iframeDocument) {
            // Get the root font size from the parent document
            const rootFontSize = window.getComputedStyle(document.documentElement).fontSize;
            // Set the root font size of the iframe document
            iframeDocument.documentElement.style.fontSize = rootFontSize;
        },

        injectFontAndCSS(iframeDocument, callback) {
            const fontFamily = process.env.VUE_APP_DEFAULT_FONT;
            const color = this.theme.textColor;
            
            // Inject the self-hosted font stylesheet; the iframe is about:blank, so the absolute
            // path resolves against the webapp origin
            const link = iframeDocument.createElement('link');
            link.href = '/fonts/fonts.css?v=1';
            link.rel = 'stylesheet';
            // Adjust height once the font files, not only the stylesheet, have loaded
            link.onload = () => (iframeDocument.fonts ? iframeDocument.fonts.ready : Promise.resolve()).then(callback);
            iframeDocument.head.appendChild(link);

            // Inject the custom CSS
            const style = iframeDocument.createElement('style');
            style.type = 'text/css';
            style.textContent = `
                .content { 
                    color: ${color};
                    font-family: '${fontFamily}', sans-serif;
                    font-size: 0.875rem;
                    font-weight: 400;
                    line-height: 1.375rem;
                    letter-spacing: 0.0071428571em;
                }
                @media (min-width: 600px) {
                    .content {
                        font-size: 1.25rem !important;
                        font-weight: 500;
                        line-height: 2rem;
                        letter-spacing: 0.0125em !important;
                    }
                }
            `;
            iframeDocument.head.appendChild(style);
        },

        /**
         * Sets the iframe height to the content container's height plus the surrounding
         * body/container spacing. Measures the container, not the body: the iframe has no
         * doctype (quirks mode), where body.scrollHeight reports the viewport height and
         * would feed the current iframe height back into the next measurement.
         */
        adjustIframeHeight(iframe, container) {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            this.debounceTimeout = setTimeout(() => {
                if (!iframe || !iframe.contentDocument || !container) {
                    return;
                }
                const bodyStyles = window.getComputedStyle(iframe.contentDocument.body);
                const containerStyles = window.getComputedStyle(container);
                const spacing =
                    parseFloat(bodyStyles.paddingTop) + parseFloat(bodyStyles.paddingBottom) +
                    parseFloat(bodyStyles.marginTop) + parseFloat(bodyStyles.marginBottom) +
                    parseFloat(containerStyles.marginTop) + parseFloat(containerStyles.marginBottom);

                iframe.style.height = `${container.scrollHeight + spacing}px`;
            }, 100);
        },

        startCheckingUserInput() {
            if (this.inputCheckInterval) {
                clearInterval(this.inputCheckInterval);
            }

            this.inputCheckInterval = setInterval(() => {
                if (!this.taskInteracted) {
                    return; // nothing is emitted before the first interaction, so the solve button stays disabled
                }
                if (this.taskScript && this.taskScript.TaskScriptTemplate && this.taskScript.TaskScriptTemplate.checkUserInput) { // task script contains TaskScriptTemplate.checkUserInput function
                    const result = this.taskScript.onCheckUserInput();
                    if (result) {                         
                        // const userInput = result.userInput ? result.userInput : ( result.userAnswers ? result.userAnswers : null );
                        console.log("User input " + JSON.stringify(result));
                        const userInput = JSON.stringify(result);
                        if (JSON.stringify(userInput) !== JSON.stringify(this.prevUserInput)) {
                            this.prevUserInput = userInput;
                            // console.log('userInput:', userInput);
                            this.$emit('input', userInput, this.getServerData(userInput, false, this.spot));
                        }
                    }
                }
            }, 500);
        },
    }
};
</script>

